import DamageLossesList from "@/controllers/damage-losses/damage-losses-list.js";

export default {
  extends: DamageLossesList,
}
